import { render, staticRenderFns } from "./UserNotes.vue?vue&type=template&id=03ec88db&scoped=true&"
import script from "./UserNotes.vue?vue&type=script&lang=js&"
export * from "./UserNotes.vue?vue&type=script&lang=js&"
import style0 from "./UserNotes.vue?vue&type=style&index=0&id=03ec88db&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ec88db",
  null
  
)

export default component.exports